
<nz-modal [(nzVisible)]="viewProposalModal" [nzTitle]="proposalDataModal" nzWidth="80vw"
  (nzOnCancel)="cancelProposalModal()" (nzOnOk)="okProposalModal()" [nzOkText]="null" nzCancelText="Close">
  <ng-container *nzModalContent>
    <div *ngIf="refreshViewPolicy" class="viewCaseSection">
      <div class="activityTimelineSec">
        <app-claims-activity-timeline [IO]="transactionDataIO" [DO]="DOName" transactionState="activity"></app-claims-activity-timeline>
      </div>
      <div>
        <app-view-policy-summary [IO]="transactionDataIO"></app-view-policy-summary>
      </div>
      <div>
         <button nz-button [nzType]="'primary'" (click)="openUWrules()" translate>
      <i nz-icon nzType="plus" nzTheme="outline"></i> UW Rules
    </button>
      </div>
    </div>
  </ng-container>
</nz-modal>

<nz-modal nzWidth="80vw" [(nzVisible)]="open" nzTitle="Underwriting Rules" (nzOnCancel)="open=false" (nzOnOk)="open =false">
  <ng-container *nzModalContent>
    <div>
      <app-rules-auto *ngIf="transactionDataIO" [IO]="transactionDataIO"></app-rules-auto>
    </div>
  </ng-container>
</nz-modal>

<div class="flexie-auto-grid p-b-20">
  <div>
    <h3 translate>Search Proposals</h3>
    <i style="font-size: 10px;"><i nz-icon nzType="exclamation-circle" class="ico-item"></i> By using the criteria from
      dropdown below you can search existing proposals.</i>

    <div class="m-t-10" style="width: 650px;">
      <app-ui-search *ngIf="transactionState != 'cacheClean'"
          [itemsPerPage]="configData?.TransactionDetailsMetaData[transactionState]?.itemsPerPage"
          [(SearchCriteria)]="CRITERIALOOKUP" (componentOutput)="fetchSearchResult($event)"
          [extraExternalParams]="extraExternalParams" (criteriaOutput)="getSelectedCriteria($event)"
          [searchURL]="configData?.TransactionDetailsMetaData[transactionState]?.searchURL"></app-ui-search>
    </div>
    
  </div>
  <div class="text-a-right">
      <div class="text-a-right">
        <button *ngIf="enableProposal" nz-button [nzType]="'primary'" nz-dropdown [nzDropdownMenu]="typeOfProposals" translate>
          <i nz-icon nzType="plus"  nzTheme="outline"></i> {{'New Proposal' | MMSTranslate}}
        </button>
        <nz-dropdown-menu #typeOfProposals="nzDropdownMenu" id="select-option" class="m-r-10">
          <ul nz-menu id="upload-menu">
                <li nz-menu-item *ngFor="let bulkUploadOption of bulkUploadOptions;let i = index"
                 (click)="createNewProposal(bulkUploadOption.key)">
                  <span>{{bulkUploadOption.type}}</span>
                </li>
          </ul>
        </nz-dropdown-menu>
      </div>


    <button id="downloadButton" *ngIf="!hideActionsInReport" class="m-5" nz-button nzType="primary" (click)="createTemplateExcel()"><i nz-icon
      nzType="download"></i> Download</button>

  </div>
</div>
<!-- NEED TO CHANGE -->
<nz-modal id="selectProduct" [(nzVisible)]="isProductModalVisible" nzTitle="Please select Product"
  (nzOnCancel)="cancelProductModal()" (nzOnOk)="okProductModal()" nzCancelText="Close" nzOkText="Proceed">
  <ng-container *nzModalContent>
    <div class="grid grid-2x grid-gap-10">
      <div>
        <h3>{{ 'Select LOB'}} </h3>
        <nz-select style="width: 100%; margin-top: 10px;" nzShowSearch nzAllowClear nzPlaceHolder="Please select LOB"
          [(ngModel)]="selectedLOB" (ngModelChange)="fetchProducts($event)">
          <nz-option *ngFor="let lob of productFamilyList ;let i = index" [nzLabel]=lob.lookupValue
            [nzValue]=lob.lookupKey></nz-option>
        </nz-select></div>
      <div> 
        <h3>{{ 'Select Product'}} </h3>
        <nz-select *ngIf="refreshProductListFl" style="width: 100%; margin-top: 10px;" nzShowSearch nzAllowClear nzPlaceHolder="Please select Product"
          [(ngModel)]="selectedProductValue">
          <nz-option *ngFor="let product of productData;let i = index" [nzLabel]=product.productNameWithVersion
            [nzValue]=product></nz-option>
        </nz-select></div>
    </div>


  </ng-container>
</nz-modal>
<!-- <div class="text-a-right">
  
  </div> -->
<!-- <h3 class="heading" translate>Last 5 Intimations</h3> -->
<div *ngIf="transactionState != 'cacheClean' && refreshAfterDataReload">
  <div class="heading-tab">
  
    <h3 class="heading" translate>{{ headingPrefix }}</h3>
    <div>
      <button class="m-r-10" nz-button nzType="primary" (click)="createTemplateExcel()" [nzLoading]="downloadLoader"><i
          nz-icon nz-tooltip nzTooltipTitle="Download latest proposals data" nzType="download">
        </i>
      </button>
      <button nz-button nz-dropdown nzPlacement="topCenter" [nzDropdownMenu]="manageHeadersMenu">View/Hide
        Columns<i nz-icon nzType="down"></i></button>
      <nz-dropdown-menu #manageHeadersMenu="nzDropdownMenu">
        <ul nz-menu style="margin-right: 10px;">
          <li nz-menu-item *ngFor="let config of searchTableHeaders">
            <label nz-checkbox [nzDisabled]="lastCheckboxPendingToBeUnticked() && config.defaultVisibilityFl"
              [(ngModel)]="config.defaultVisibilityFl" (ngModelChange)="manageHeaders($event)">{{config.keyDescription}}</label>
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
  </div>

  <app-generic-zero-ui [list]="searchResultsList" icon="file-search" [title]="intimationZeroState.title"
  [message]="intimationZeroState.message" [icon]="intimationZeroState.icon"></app-generic-zero-ui>
  
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <div class="ant-table-filter-dropdown">
      <div class="search-box">
        <input type="text" nz-input placeholder="Filter..." [(ngModel)]="searchValue" />
        <button nz-button nzSize="small" nzType="primary" (click)="searchConfiguration()"
          class="search-button">
          Filter
        </button>
        <button nz-button nzSize="small" (click)="reset()">Reset</button>
      </div>
    </div>
  </nz-dropdown-menu>

  <nz-drawer [nzClosable]="true" [nzWidth]="400" [nzPlacement]="'right'" nzTitle="{{'Activity Timeline' | MMSTranslate}}"
    [nzVisible]="activityPanelOpen" (nzOnClose)="activityPanel(0)">
    <ng-container *nzDrawerContent>
      <app-claims-activity-timeline [IO]="transactionDataIO" transactionState="activity"></app-claims-activity-timeline>
    </ng-container>
  </nz-drawer>
  

  <nz-table *ngIf="searchResultsList && searchResultsList.length && enableNewTable && searchTableHeaders" #genericSearchTable [nzData]="searchResultsList" [nzSize]="'default'"
    [nzLoading]="searchDataIsInProcess" [nzScroll]="(returnVisibleColumnsLength() >= 10) ? { x: '1400px'} : null"
    [nzPageIndex]="currentPageIndex" (nzPageIndexChange)="pageIndexChanged($event)">
    <thead (nzSortOrderChange)="sort($event)" nzSingleSort>
      <tr>
        <ng-container *ngFor="let config of searchTableHeaders;let index = i">
          <th scope="col" [nzWidth]="config.width" *ngIf="config.defaultVisibilityFl">
          
            <div style="display: flex;">
              <div>{{config.keyDescription}}</div>
              <div><app-column-actions [key]="config.key" [dataContainer]="genericSearchTable"
                  [sourceData]="searchResultsList">
                </app-column-actions></div>
            </div>
          </th>
        </ng-container>
        <th nzRight="0px" nzAlign="center" class="text-a-center" [nzWidth]="'100px'">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of genericSearchTable.data">
        <ng-container
          *ngFor="let config of searchTableHeaders;let index = i">
          <td *ngIf="config.key == 'proposalNum' && config.defaultVisibilityFl"
            [ngClass]="{'highlight-column-data': filteredColumn === config.key}">
            <a (click)="openTransactionDetails(serviceTask,data.guid,data.baseProductCd,data.baseProductFamilyCd)">{{data[config.key] }}</a>
          </td>
          <td class="fixed-width-data"
            *ngIf="config.key != 'proposalNum' && config.defaultVisibilityFl"
            [ngClass]="{'highlight-column-data': filteredColumn === config.key}">
            <span *ngIf="data[config.key] && config.valueInputType == 'IDENTITY_NUM'">{{data[config.key]}}</span>
            <span *ngIf="data[config.key] && config.valueInputType == 'NUMBER'">{{data[config.key]}}</span>
            <span *ngIf="data[config.key] && config.valueInputType == 'DATE'">{{getDateString(data[config.key])}}</span>
            <span *ngIf="data[config.key] && config.valueInputType == 'TEXT' && !config.lookupName">{{data[config.key]}}</span>
            <span *ngIf="data[config.key] && config.valueInputType == 'LOOKUP' && config.lookupName">{{(data[config.key] |
              technicalTranslate : config.lookupName)}}</span>
            <span *ngIf="data[config.key] && config.valueInputType == 'CURRENCY'">{{(data[config.key] |
              CurrencyFormatter)}}</span>
            <span *ngIf="!data[config.key]" class="nodatafound">No data found</span>
          </td>
        </ng-container>
         
        <td nzRight="0px" nzAlign="center" class="text-a-center" [nzWidth]="'100px'">
          <a nz-dropdown [nzDropdownMenu]="menu">Actions
            <i nz-icon nzType="down"></i>
          </a>
          <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu nzSelectable>
                  <li nz-menu-item *ngIf="data.statusCd == 'DRAFT' || data.statusCd == 'BRANCHDRAFT' || data.statusCd == 'NBBRANCHDECOMPLETE'">
                    <a (click)="openTransactionDetails(serviceTask,data.guid,data.baseProductCd, data.baseProductFamilyCd)">Edit Transaction</a>
                  </li>
                  <li nz-menu-item *ngIf="data.statusCd != 'DRAFT' && data.statusCd != 'BRANCHDRAFT' && data.statusCd != 'NBBRANCHDECOMPLETE'">
                    <a (click)="openTransactionDetails(serviceTask,data.guid,data.baseProductCd,data.baseProductFamilyCd)">View Transaction</a>
                  </li>
                  <li nz-menu-item><a (click)="openActivityTimeline(data.guid)">Activity Timeline</a></li>
              </ul>
          </nz-dropdown-menu>
         </td>
      </tr>
    </tbody>
  </nz-table>
</div>